export default "__VITE_ASSET__e16c53f7__"